const serverApi = window.location.hostname
/**
 * 开发环境下的路由类型微应用注册，比如系统管理模块等
 * 生产环境下是根据后台接口动态加载注册
 * 无特殊情况，路由类型微应用渲染的container都是layout页面的#subapp-view
 * @Author: tanyc 
 * @Date: 2021-03-11 10:39:16 
 */
const apps = {
  sysman:{
    id: 'subapp-view-sysman',
    name: 'sysman',
    entry: `http://${serverApi}:8501`,
    container: '#subapp-view-sysman',
    activeRule: '/sysman',
  },
} as Record<string, any>

const microAppConfig = []

for(let i in apps){
  microAppConfig.push(apps[i])
}

export default apps;

export {
  microAppConfig
}